// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ndiv h6[data-v-1f7b47ee] {\n  color: var(--dark-green-50, #809795);\n  font-size: 0.9rem !important;\n  font-weight: 400;\n}\ndiv h6 strong[data-v-1f7b47ee] {\n  font-weight: 600;\n}\n", ""]);
// Exports
module.exports = exports;
